import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedImageTabsAlertsQueryParamType,
  GetDamagedImageTabsAlertsResponseQueryType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedImageTabsAlerts/getDamagedImageTabsAlertsQuery.type';

export const getInitialVisitImageTabsAlertsQueryFunctions = (
  params: GetDamagedImageTabsAlertsQueryParamType,
): Promise<GetDamagedImageTabsAlertsResponseQueryType> =>
  fetchApi.get(
    `/initial/reports/${params.id}/images/adjuster/entry_tabs/alerts/`,
    {
      params: {
        id: params.id,
      },
    },
  );
